import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl, sortStr } from "../../../../../common/helpers/helpers";
import SortableHeader from "../../../../../components/atoms/SortableHeader";
import {
  approxAlto,
  approxPelati,
  lightGreen,
  pastelOrange,
} from "../../../../../common/helpers/colors";

const labels = {
  recruitment: "Status",
  title: "Title",
  phase: "Phase",
  nctid: "nctid",
};

const inProgress = [
  "Recruiting",
  "Available",
  "Enrolling by invitation",
  "Approved for marketing",
];

const active = ["Active, not recruiting", "Not yet recruiting"];

const sortByStatus = (a, b) => {
  const x = a.recruitment;
  const y = b.recruitment;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

const sortByTitle = (a, b) => {
  const x = a.title;
  const y = b.title;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

const sortByPhase = (a, b) => sortStr(a.phase, b.phase);
const sortByNctid = (a, b) => sortStr(a.nctid, b.nctid);

const colorStatus = (status) => {
  if (inProgress.includes(status)) {
    return lightGreen;
  }
  if (active.includes(status)) {
    return pastelOrange;
  }
  if (status === "Unknown status") {
    return approxAlto;
  }
  return approxPelati;
};

function JaxCkbClinicalTrialsContent({
  items,
  sortedField,
  isAsc,
  toggleField,
}) {
  return (
    <div className="tw-overflow-y-auto tw-ml-0 tw-mb-8">
      <table className="varsome-table-overflow varsome-table-sorted">
        <thead>
          <tr>
            <SortableHeader
              sort={(key) => toggleField(sortByStatus, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="recruitment"
              width="20%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByTitle, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="title"
              width="50%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByPhase, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="phase"
              width="15%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByNctid, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="nctid"
              width="15%"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((item, m) => {
            const statusColor = colorStatus(item.recruitment);

            return (
              <tr key={`${m}-${new Date().getTime()}`}>
                <td className="tw-font-bold" style={{ color: statusColor }}>
                  {item.recruitment || "-"}
                </td>

                <td>{item.title || "- "}</td>
                <td>{item.phase || "-"}</td>
                <td>
                  {item.nctid ? (
                    <a
                      href={getVarsoUrl(
                        `https://clinicaltrials.gov/ct2/show/${item.nctid}`
                      )}
                      target="_blank"
                    >
                      {item.nctid}
                    </a>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

JaxCkbClinicalTrialsContent.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      nctid: PropTypes.string,
      phase: PropTypes.string,
      recruitment: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  sortedField: PropTypes.string,
  isAsc: PropTypes.bool,
  toggleField: PropTypes.func.isRequired,
};

JaxCkbClinicalTrialsContent.defaultProps = {
  items: [],
  sortedField: null,
  isAsc: true,
};

export default JaxCkbClinicalTrialsContent;
